import {
  LayoutGrid,
  List,
  ListItem,
  TypographyV3,
} from '@jouzen/ecom-components';

import Image from '@/app/components/Image';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@/app/components/Table';

const SharedContent = () => {
  return (
    <>
      <LayoutGrid>
        <div className="col-main">
          <TypographyV3 variant="h2" Element="h1">
            EU Declaration of Conformity
          </TypographyV3>
          <List Element="ol">
            <ListItem>Model name: Gen3 and Gen3 charger</ListItem>
            <ListItem>
              Address: Ōura Health Oy, Elektroniikkatie 10, 90590 Oulu, Finland
            </ListItem>
            <ListItem>
              This declaration of conformity is issued under the sole
              responsibility of the manufacturer
            </ListItem>
            <ListItem>
              Object of the declaration, this is identification of the radio
              equipment allowing traceability;
              <Image
                className="my-4 md:w-6/12"
                src="/declaration-of-conformity/radio-equipment-gen3"
                alt="Oura ring with CE stamped charger"
                width={562}
                height={421}
              />
            </ListItem>
            <ListItem>
              <TypographyV3>
                The object of the declaration described above is in conformity
                with the relevant Community harmonisation:
              </TypographyV3>
              <List Element="ul" condensed className="mt-4">
                <ListItem>Directive2014/53/EU–RadioEquipment</ListItem>
                <ListItem>Directive2011/65/EU-RoHS</ListItem>
                <ListItem>Directive2012/19/EU–WEEE</ListItem>
              </List>
            </ListItem>
            <ListItem>
              <TypographyV3>
                The conformity with the essential requirements of the following
                directives has been demonstrated against the standards:
              </TypographyV3>
              <Table className="my-6">
                <TableHead>
                  <TableRow>
                    <TableCell Element="th" scope="col" className="w-1/2">
                      Standard reference
                    </TableCell>
                    <TableCell Element="th" scope="col" className="w-1/2">
                      Article of Directive 2014/53/EU
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <List Element="ul" condensed unstyled>
                        <ListItem>
                          EN 62368-1:2014 + AC:2015 + A11:2017
                        </ListItem>
                        <ListItem>EN 62479:2010</ListItem>
                      </List>
                    </TableCell>
                    <TableCell>
                      3.1 (a): Health and Safety of the User
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <List Element="ul" condensed unstyled>
                        <ListItem>
                          Draft ETSI EN 301 489-1 V2.2.3, EN 301 489-17 V3.2.4
                        </ListItem>
                        <ListItem>EN 55011:2016/A1:2017</ListItem>
                        <ListItem>EN 61000-6-1:2007</ListItem>
                        <ListItem>EN 61000-6-3:2007/A1:2011/AC:2012</ListItem>
                        <ListItem>EN 62233:2008/AC:2008</ListItem>
                      </List>
                    </TableCell>
                    <TableCell>
                      3.1 (b): Electromagnetic Compatibility
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <List Element="ul" condensed unstyled>
                        <ListItem>ETSI EN 300 328 v2.2.2</ListItem>
                      </List>
                    </TableCell>
                    <TableCell>
                      3.2 : Effective use of spectrum allocated
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </ListItem>
            <ListItem>
              The Notified Body (Dekra, 1909) has performed the documentation
              assessment of the product and issued the EU-Type Examination
              Certificate according to directive 2014/53/EU
            </ListItem>
            <ListItem>
              <TypographyV3>
                Thus,{' '}
                <strong>
                  <abbr className="no-underline" title="Conformité Européen">
                    CE
                  </abbr>
                </strong>{' '}
                is placed on the product.
              </TypographyV3>
              <TypographyV3>
                The Technical Documentation (TD) relevant to the product
                described above and which supports this Declaration of
                Conformity, is held at: Ōura Health Oy, Elektroniikkatie 10,
                90590 Oulu, Finland
              </TypographyV3>
            </ListItem>
            <ListItem>
              <TypographyV3>
                ŌURA is the company behind the Oura Ring — a wearable health
                platform that delivers personalized health data, insights and
                daily guidance. At ŌURA, our mission is to empower every person
                to own their inner potential. We believe health is a daily
                practice and, with insights and guidance, you can control the
                course of your health to live a more balanced life. The Oura
                Ring Gen3 is smarter and more comprehensive than ever. Your
                daily health guide for a balanced life, with 24/7 health
                tracking and personalized insights that translate your body's
                hidden messages and have the power to transform how you feel,
                day and night. Updated with our new, more accurate,
                state-of-the-art sleep staging algorithm, daytime and workout
                heart rate monitoring, blood oxygen (SpO2) sensing, Period
                Prediction, and so much more.
              </TypographyV3>
            </ListItem>
            <ListItem>
              <TypographyV3>
                Signed for and on behalf of Ōura Health Oy, in San Francisco
                10/11/2021
              </TypographyV3>
              <TypographyV3 className="my-2">Michael Chapp</TypographyV3>
            </ListItem>
          </List>
        </div>
      </LayoutGrid>
      <hr className="mx-auto my-8 max-w-3xl" />
      <LayoutGrid>
        <div className="col-main lg:col-start-3 lg:col-end-13">
          <TypographyV3 variant="h2" Element="h2">
            EU Declaration of Conformity
          </TypographyV3>
          <List Element="ol">
            <ListItem>Model name: OURA and OURA charger</ListItem>
            <ListItem>
              Address: Ōura Health Oy, Elektroniikkatie 10, 90590 Oulu, Finland
            </ListItem>
            <ListItem>
              This declaration of conformity is issued under the sole
              responsibility of the manufacturer
            </ListItem>
            <ListItem>
              Object of the declaration, this is identification of the radio
              equipment allowing traceability;
              <Image
                className="my-4 md:w-6/12"
                src="/declaration-of-conformity/radio-equipment"
                format="png"
                alt="Oura ring with CE stamped charger"
                width={562}
                height={302}
              />
            </ListItem>
            <ListItem>
              <TypographyV3>
                The object of the declaration described above is in conformity
                with the relevant Community harmonisation:
              </TypographyV3>
              <List Element="ul" condensed className="mt-4">
                <ListItem>Directive2014/53/EU–RadioEquipment</ListItem>
                <ListItem>Directive2011/65/EU-RoHS</ListItem>
                <ListItem>Directive2012/19/EU–WEEE</ListItem>
              </List>
            </ListItem>
            <ListItem>
              <TypographyV3>
                The conformity with the essential requirements of the following
                directives has been demonstrated against the standards:
              </TypographyV3>
              <Table className="my-6">
                <TableHead>
                  <TableRow>
                    <TableCell Element="th" scope="col" className="w-1/2">
                      Standard reference
                    </TableCell>
                    <TableCell Element="th" scope="col" className="w-1/2">
                      Article of Directive 2014/53/EU
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <List Element="ul" condensed unstyled>
                        <ListItem>
                          EN 60950-1:2006 + A11:2009 + A1:2010 + A12:2011 +
                          AC:2011 + A2:2013
                        </ListItem>
                        <ListItem>EN 62479:2010</ListItem>
                      </List>
                    </TableCell>
                    <TableCell>
                      3.1 (a): Health and Safety of the User
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <List Element="ul" condensed unstyled>
                        <ListItem>
                          Draft ETSI EN 301 489-1 V2.2.0 (2017-03) Draft EN 301
                          489-17 V3.2.0 (2017-03)
                        </ListItem>
                        <ListItem>EN 55011:2016/A1:2017</ListItem>
                        <ListItem>EN 61000-6-1:2007</ListItem>
                      </List>
                    </TableCell>
                    <TableCell>
                      3.1 (b): Electromagnetic Compatibility
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <List Element="ul" condensed unstyled>
                        <ListItem>ETSI EN 300 328 v2.1.1 (2016-11)</ListItem>
                      </List>
                    </TableCell>
                    <TableCell>
                      3.2 : Effective use of spectrum allocated
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </ListItem>
            <ListItem>
              The Notified Body (Dekra, 1909) has performed the documentation
              assessment of the product and issued the EU-Type Examination
              Certificate according to directive 2014/53/EU
            </ListItem>
            <ListItem>
              <TypographyV3>
                Thus,{' '}
                <strong>
                  <abbr className="no-underline" title="Conformité Européen">
                    CE
                  </abbr>
                </strong>{' '}
                is placed on the product.
              </TypographyV3>
              <TypographyV3>
                The Technical Documentation (TD) relevant to the product
                described above and which supports this Declaration of
                Conformity, is held at: Ōura Health Oy, Elektroniikkatie 10,
                90590 Oulu, Finland
              </TypographyV3>
            </ListItem>
            <ListItem>
              <TypographyV3>
                OURA is a revolutionary wellness ring and app, designed to help
                user to get more restful sleep and to perform better. It enables
                user to learn how the lifestyle choices affect user's sleep, and
                how the quality of the sleep affects user's ability to perform.
              </TypographyV3>
              <TypographyV3 className="my-2">
                The OURA ring can automatically tell when user is sleeping. When
                user goes to sleep, the OURA ring analyzes the quality of the
                rest and recovery by measuring the heart rate (optically),
                respiration rate, body temperature, and movement. While user is
                awake, it monitors the duration and intensity of the activities,
                and the time user spends sitting.
              </TypographyV3>
              <TypographyV3 className="my-2">
                The OURA app integrates and visualizes this data to identify
                patterns between the sleep quality and daily activities. By
                understanding how well user slept and recharged, it can
                determine the readiness to perform and help user adjust the
                intensity and duration of the day's activities. It can also
                uncover actionable insights for changes to the daily activities
                that can help user sleep better.
              </TypographyV3>
            </ListItem>
            <ListItem>
              <TypographyV3>
                Signed for and on behalf of Ōura Health Oy, in Oulu 27/6/2018
              </TypographyV3>
              <TypographyV3 className="my-2">Michael Chapp</TypographyV3>
            </ListItem>
          </List>
        </div>
      </LayoutGrid>
      <hr className="mx-auto my-8 max-w-3xl" />
      <LayoutGrid>
        <div className="col-main lg:col-start-3 lg:col-end-13">
          <TypographyV3 variant="h2" Element="h2">
            EU Declaration of Conformity
          </TypographyV3>
          <TypographyV3 weight="bold">We</TypographyV3>
          <TypographyV3>Oura Health Oy</TypographyV3>
          <TypographyV3>Elektroniikkatie 10</TypographyV3>
          <TypographyV3>90590 Oulu</TypographyV3>
          <TypographyV3>Finland</TypographyV3>
          <TypographyV3 weight="bold" className="mt-4">
            Declare under our sole responsibility that the following products
          </TypographyV3>
          <TypographyV3 className="mt-2">Equipment: Wellness ring</TypographyV3>
          <TypographyV3 className="mt-2">Brand name: Oura</TypographyV3>
          <TypographyV3 className="mt-2">Model/type: LE1</TypographyV3>
          <Image
            className="my-4 md:w-6/12"
            src="/declaration-of-conformity/radio-equipment-gollum"
            format="png"
            alt="Gucci oura ring"
            width={578}
            height={546}
          />
          <TypographyV3 weight="bold" className="mt-2">
            is in conformity with the
          </TypographyV3>
          <TypographyV3 className="mt-2">
            <strong>Directive</strong> 2014/53/EU (RED)
          </TypographyV3>
          <TypographyV3 className="mt-2">
            <strong>Directive</strong> 2011/65/EU (RoHS)
          </TypographyV3>
          <TypographyV3 weight="bold" className="mt-2">
            and the following standards and technical specifications have been
            applied
          </TypographyV3>
          <Table className="my-6 text-sandstone-500">
            <TableBody>
              <TableRow>
                <TableCell>RF spectrum use</TableCell>
                <TableCell>EN 300 328 V2.2.2</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>EMC (article 3.1b)</TableCell>
                <TableCell>
                  <List Element="ul" condensed unstyled>
                    <ListItem>EN 301 489-1 V2.2.3</ListItem>
                    <ListItem>EN 301 489-17 V3.2.4</ListItem>
                    <ListItem>EN 55011:2016/A11:2020</ListItem>
                    <ListItem>EN 61000-6-1:2017</ListItem>
                    <ListItem>EN 61000-6-3:2021</ListItem>
                  </List>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Health & Safety</TableCell>
                <TableCell>
                  <List Element="ul" condensed unstyled>
                    <ListItem>
                      EN 62368-1:2014 + AC:2015 + AC:2017 + A11:2017
                    </ListItem>
                    <ListItem>EN 62479:2010</ListItem>
                  </List>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <TypographyV3>
            Signed for and on behalf of Ōura Health Oy, in Oulu 24.03.2022
          </TypographyV3>
          <TypographyV3 className="my-2">Jyri Suokas</TypographyV3>
          <TypographyV3>Senior Quality Specialist</TypographyV3>
        </div>
      </LayoutGrid>
      <hr className="mx-auto my-8 max-w-3xl" />
      <LayoutGrid>
        <div className="col-main lg:col-start-3 lg:col-end-13">
          <TypographyV3 variant="h2" Element="h2">
            EU Declaration of Conformity
          </TypographyV3>
          <TypographyV3 weight="bold">We</TypographyV3>
          <TypographyV3>Oura Health Oy</TypographyV3>
          <TypographyV3>Elektroniikkatie 10</TypographyV3>
          <TypographyV3>90590 Oulu</TypographyV3>
          <TypographyV3>Finland</TypographyV3>
          <TypographyV3 weight="bold" className="mt-4">
            Declare under our sole responsibility that the following products
          </TypographyV3>
          <TypographyV3 className="mt-2">
            Equipment: Inductive Charger
          </TypographyV3>
          <TypographyV3 className="mt-2">Brand name: Oura</TypographyV3>
          <TypographyV3 className="mt-2">Model/type: LE1 Charger</TypographyV3>
          <Image
            className="my-4 md:w-6/12"
            src="/declaration-of-conformity/radio-equipment-gen3-gollum-charger"
            format="png"
            alt="Gucci oura ring charger"
            width={578}
            height={516}
          />
          <TypographyV3 weight="bold" className="mt-2">
            is in conformity with the
          </TypographyV3>
          <TypographyV3 className="mt-2">
            <strong>Directive</strong> 2014/30/EU (EMC)
          </TypographyV3>
          <TypographyV3 className="mt-2">
            <strong>Directive</strong> 2011/35/EU (LVD)
          </TypographyV3>
          <TypographyV3 weight="bold" className="mt-2">
            and the following standards and technical specifications have been
            applied
          </TypographyV3>
          <Table className="my-6 text-sandstone-500">
            <TableBody>
              <TableRow>
                <TableCell>2014/30/EU (EMC)</TableCell>
                <TableCell>
                  <List Element="ul" condensed unstyled>
                    <ListItem>EN 55011 (2016)/ A11 (2020)</ListItem>
                    <ListItem>EN 61000-6-1 (2017)</ListItem>
                    <ListItem>EN 61000-6-3 (2021)</ListItem>
                  </List>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>2011/35/EU (LVD)</TableCell>
                <TableCell>
                  <List Element="ul" condensed unstyled>
                    <ListItem>
                      EN 62368-1:2014 + AC:2015 + AC:2017 + A11:2017
                    </ListItem>
                    <ListItem>EN 62233 (2008)/ AC (2008)</ListItem>
                  </List>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <TypographyV3>
            Signed for and on behalf of Ōura Health Oy, in Oulu 24.03.2022
          </TypographyV3>
          <TypographyV3 className="my-2">Jyri Suokas</TypographyV3>
          <TypographyV3>Senior Quality Specialist</TypographyV3>
        </div>
      </LayoutGrid>
    </>
  );
};

export default SharedContent;
